// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/Iconwallpaper2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0!important;
  padding: 0!important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

html, body, .login {
  padding: 0;
  height: 100%;
  font-family: 'Roboto', 'Mukta', sans-serif;
}

.login {
  /* background: url("../assets/bg-image.jpg") no-repeat center center fixed; */
  background-size: cover;
}
.wallpaper--icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: #fcfcfc;
  background-attachment: fixed;
  font-family: 'Roboto', sans-serif;
}
/* profilecard starts*/
/* [class*="profileSection"] {
  transform: translate3d(0, 0, 0);
  animation: fadeInOut 5s 2, autoSwipeUp 10s steps(2, end) 1 both;
} */
@keyframes moveForward0{
  0% {
    transform: translate3d(58px, 0, 0) scale(0.92);
  }
  100% {
    transform: translate3d(-30px, 0, 0) scale(0.96);
  }
}
@keyframes moveForward1{
  0% {
    transform: translate3d(30px, 0, 0) scale(0.96);
  }
  100% {
    transform: translate3d(-10px, 0, 0) scale(1);
  }
}
@keyframes autoSwipeUp{
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, -872px, 0)
  }
}
@keyframes bgColorFade {
  from {background-color: #f0fffb}
  to{background-color: #ffffff}
}

@keyframes pageLoader{
  0% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  99% {
    z-index: 9999;
  }
  100% {
    opacity: 0;
    z-index: -1;
  }
}
@keyframes profileFade {
  from {
    opacity: 0
  }
  to {opacity: 1}
}
@keyframes shakeAndDeny{
  0% {
    transform: translate3d(0, 0, 0) skew(0);
  }
  25% {
    transform: translate3d(-30px, 0, 0) skew(10deg, 10deg);
  }
  50% {
    transform: translate3d(0, 0, 0) skew(0);
  }
  75% {
    transform: translate3d(30px, 0, 0) skew(-10deg, -10deg);
  }
  100% {
    transform: translate3d(0, 0, 0) skew(0);
  }
}
@keyframes fadeInOut{
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 0.8
  }
  100% {
    opacity: 0.5;
  }
}

/* sleek scrollbar */
.gsleekScroll {
  width: 870px; 
  display: flex; 
  overflow-x: auto;
  overflow-y: hidden; 
  flex: 1 1;
  margin: 0 15px;
}
.gsleekScroll::-webkit-scrollbar {
  width: 5px;
  height: 8px;
}
.gsleekScroll::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.gsleekScroll::-webkit-scrollbar-thumb:hover{
  background: #5BC2A8;
  cursor: pointer;
}

.gsleekScroll::-webkit-scrollbar-track {
  background: #fafafa;
}

/* Responsive card starts*/
@media only screen and (min-width: 1700px){
  .searchBarOuterWrapper {
      transform: scale(1.2);
  }
  .MuiTypography-body2 {
      font-size: 1rem;
  }
}
/* Responsive card ends*/
/* Camera click button */
#container-circles {
  bottom: 150px !important;
}`, "",{"version":3,"sources":["webpack://./src/style/index.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE;aACW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,6EAA6E;EAC7E,sBAAsB;AACxB;AACA;EACE,mDAA+C;EAC/C,yBAAyB;EACzB,4BAA4B;EAC5B,iCAAiC;AACnC;AACA,sBAAsB;AACtB;;;GAGG;AACH;EACE;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;AACF;AACA;EACE;IACE,8CAA8C;EAChD;EACA;IACE,4CAA4C;EAC9C;AACF;AACA;EACE;IACE,+BAA+B;EACjC;EACA;IACE;EACF;AACF;AACA;EACE,MAAM,yBAAyB;EAC/B,GAAG,yBAAyB;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,WAAW;EACb;AACF;AACA;EACE;IACE;EACF;EACA,IAAI,UAAU;AAChB;AACA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,sDAAsD;EACxD;EACA;IACE,uCAAuC;EACzC;EACA;IACE,uDAAuD;EACzD;EACA;IACE,uCAAuC;EACzC;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE;EACF;EACA;IACE,YAAY;EACd;AACF;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;EACP,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE;MACI,qBAAqB;EACzB;EACA;MACI,eAAe;EACnB;AACF;AACA,wBAAwB;AACxB,wBAAwB;AACxB;EACE,wBAAwB;AAC1B","sourcesContent":["body {\n  margin: 0!important;\n  padding: 0!important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f5f5f5;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\nhtml, body, .login {\n  padding: 0;\n  height: 100%;\n  font-family: 'Roboto', 'Mukta', sans-serif;\n}\n\n.login {\n  /* background: url(\"../assets/bg-image.jpg\") no-repeat center center fixed; */\n  background-size: cover;\n}\n.wallpaper--icon {\n  background: url(\"../assets/Iconwallpaper2.png\");\n  background-color: #fcfcfc;\n  background-attachment: fixed;\n  font-family: 'Roboto', sans-serif;\n}\n/* profilecard starts*/\n/* [class*=\"profileSection\"] {\n  transform: translate3d(0, 0, 0);\n  animation: fadeInOut 5s 2, autoSwipeUp 10s steps(2, end) 1 both;\n} */\n@keyframes moveForward0{\n  0% {\n    transform: translate3d(58px, 0, 0) scale(0.92);\n  }\n  100% {\n    transform: translate3d(-30px, 0, 0) scale(0.96);\n  }\n}\n@keyframes moveForward1{\n  0% {\n    transform: translate3d(30px, 0, 0) scale(0.96);\n  }\n  100% {\n    transform: translate3d(-10px, 0, 0) scale(1);\n  }\n}\n@keyframes autoSwipeUp{\n  0% {\n    transform: translate3d(0, 0, 0);\n  }\n  100% {\n    transform: translate3d(0, -872px, 0)\n  }\n}\n@keyframes bgColorFade {\n  from {background-color: #f0fffb}\n  to{background-color: #ffffff}\n}\n\n@keyframes pageLoader{\n  0% {\n    opacity: 1;\n  }\n  75% {\n    opacity: 1;\n  }\n  99% {\n    z-index: 9999;\n  }\n  100% {\n    opacity: 0;\n    z-index: -1;\n  }\n}\n@keyframes profileFade {\n  from {\n    opacity: 0\n  }\n  to {opacity: 1}\n}\n@keyframes shakeAndDeny{\n  0% {\n    transform: translate3d(0, 0, 0) skew(0);\n  }\n  25% {\n    transform: translate3d(-30px, 0, 0) skew(10deg, 10deg);\n  }\n  50% {\n    transform: translate3d(0, 0, 0) skew(0);\n  }\n  75% {\n    transform: translate3d(30px, 0, 0) skew(-10deg, -10deg);\n  }\n  100% {\n    transform: translate3d(0, 0, 0) skew(0);\n  }\n}\n@keyframes fadeInOut{\n  0% {\n    opacity: 0.5;\n  }\n  50% {\n    opacity: 0.8\n  }\n  100% {\n    opacity: 0.5;\n  }\n}\n\n/* sleek scrollbar */\n.gsleekScroll {\n  width: 870px; \n  display: flex; \n  overflow-x: auto;\n  overflow-y: hidden; \n  flex: 1;\n  margin: 0 15px;\n}\n.gsleekScroll::-webkit-scrollbar {\n  width: 5px;\n  height: 8px;\n}\n.gsleekScroll::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 4px;\n}\n\n.gsleekScroll::-webkit-scrollbar-thumb:hover{\n  background: #5BC2A8;\n  cursor: pointer;\n}\n\n.gsleekScroll::-webkit-scrollbar-track {\n  background: #fafafa;\n}\n\n/* Responsive card starts*/\n@media only screen and (min-width: 1700px){\n  .searchBarOuterWrapper {\n      transform: scale(1.2);\n  }\n  .MuiTypography-body2 {\n      font-size: 1rem;\n  }\n}\n/* Responsive card ends*/\n/* Camera click button */\n#container-circles {\n  bottom: 150px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
